import {TIPO_AMB_DEV, TIPO_AMB_PROD} from '../util/constantes'


/* ______________________________ altera quando publicar em producao___________________________________________*/ 


export const AMBIENTE = TIPO_AMB_PROD;

export const NOME_APP = "B2Negocia";

export const VERSAO = "1.1.0";

export const ANO_VERSAO = "2024";

export const WS_URL_DEV = "http://localhost";

export const WS_API_DEV = "/api/";

export const WS_USR_DEV = "d3v";

export const WS_PWD_DEV = "d3v";

export const WS_URL_APP_DEV = "http://localhost:3000";

export const WS_URL_PROD = "https://b2negocia.com";

export const WS_API_PROD = "/api/";

export const WS_USR_PROD = "b2negociaUsrApp";

export const WS_PWD_PROD = "c6riTZLTSe0Ivv9eU8sA0GZfCBSsilzYBWtWM0YI1q5vxGUh46qontVBqM4qbvw5Z7iNsTg5";

export const GOOGLE_CLIENT_ID = "527809323451-hp2kb3rue2c3to8p94b4387mr7r9o7ff.apps.googleusercontent.com";

export const WS_URL_APP_PROD = "https://b2negocia.com";

export const WS_URL_LOJA = "https://b2negocia.com/lojaExterno/";

export const WS_URL_FICHA_DENUNCIA = (AMBIENTE==TIPO_AMB_DEV?WS_URL_DEV:WS_URL_PROD)+WS_API_DEV+"ficha_denuncia.php?token=";